export default "__VITE_ASSET__DMU$wJxO__"